import script from "./CardEmpresas.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardEmpresas.vue?vue&type=script&lang=ts&setup=true"

import "./CardEmpresas.vue?vue&type=style&index=0&id=401def30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-401def30"]])

export default __exports__